import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars
import {autobind} from 'core-decorators';

import {API_DOCS_TOC, API_DOCS_SECTIONS} from './constants/constants';
import {Metadata} from '../common/metadata';

import {APIDocPage} from './page';

import {NavBar} from './components/NavBar';
import {TOC} from './components/TOC';
import {QuickstartSection} from './components/sections/QuickstartSection';
import {EndpointsSection} from './components/sections/EndpointsSection';
import {CustomAPISection} from './components/sections/CustomAPISection';
import {LocalizationSection} from './components/sections/LocalizationSection';
import {ResponseObjectsSection} from './components/sections/ResponseObjectsSection';
import {ContentFilterSection} from './components/sections/ContentFilterSection';
import {SDKSection} from './components/sections/SDKSection';
import {AttributionSection} from './components/sections/AttributionSection';
import {APITermsSection} from './components/sections/APITermsSection';
import {SupportSection} from './components/sections/SupportSection';

import {window, document} from '../common/util';

export class IndexPage extends APIDocPage {
    lastScrollPosition?: null|number;
    currentScrollPosition?: null|number;
    intervalCheck?: ReturnType<typeof setInterval>;
    tocSections: null|HTMLElement[];
    document?: Document;

    constructor(props: jsx.Props, context: jsx.AppGlobals) {
        super(props, context);
        this.state = {
            ...this.state,
            hash: '',
        };
    }
    pageInit() {
        super.pageInit();
        this.setCanonicalURL('/gifapi/documentation');
        this.title = 'GIF API - Better, Faster & Free | Tenor Documentation';
        this.description = 'Tenor Search delivers the most relevant GIFs in 30+ languages. Integrate Tenor’s GIF API into your application in a matter of minutes with this handy guide.';
        this.state = {
            ...this.state,
            hash: this.context.router.history.location.hash.slice(1),
        };
        this.tocSections = null;
    }

    componentDidMount() {
        this.tocSections = this.getTocElements();
        this.document = window.document;
        this.lastScrollPosition = this.getCurrentPosition();
        this.currentScrollPosition = null;
        this.intervalCheck = setInterval(this.updateLocation, 500);
    }

    componentWillUnmount() {
        clearInterval(this.intervalCheck);
    }

    getCurrentPosition(): number {
        return (window.pageYOffset !== undefined) ?
            window.pageYOffset :
            (document.documentElement || document.body.parentElement ||
                document.body).scrollTop;
    }

    getTocElements(): HTMLElement[] {
        return API_DOCS_SECTIONS.map((id) => {
            return document.getElementById(id);
        } );
    }

    updateHashHistory(id) {
        if (id !== this.state.hash) {
            this.setState({hash: id});
            window.history.replaceState(null, '', `#${id}`);
        }
    }

    @autobind
    updateLocation() {
        let currentSection = null;
        const marginOffset = 0;
        this.currentScrollPosition = this.getCurrentPosition();
        if (this.currentScrollPosition !== this.lastScrollPosition) {
            for (let i = 0; i < this.tocSections.length; i++) {
                if (this.tocSections[i].offsetTop - marginOffset -
                    this.currentScrollPosition >= 0) {
                    currentSection = i > 0 ?
                        this.tocSections[i - 1] :
                        this.tocSections[0];
                    break;
                }
            }
            currentSection = currentSection ?
                currentSection :
                this.tocSections[this.tocSections.length - 1];
            this.updateHashHistory(currentSection.id);
            this.lastScrollPosition = this.currentScrollPosition;
        }
    }

    renderPage() {
        return (
            <div className="IndexPage APIDocPage TOCPage">
                <Metadata page={this}/>
                <NavBar pageLabelPrefix='api-docs' tocSections={API_DOCS_TOC} hash={this.state.hash}/>
                <div className="main-view">
                    <div className="container">
                        <TOC
                            pageLabelPrefix='api-docs'
                            type='sidebar'
                            tocSections={API_DOCS_TOC}
                            hash={this.state.hash}
                        />

                        <div id="main-content">

                            <QuickstartSection/>

                            <EndpointsSection/>

                            <CustomAPISection/>

                            <ResponseObjectsSection/>

                            <LocalizationSection/>

                            <ContentFilterSection/>

                            <SDKSection/>

                            <APITermsSection/>

                            <AttributionSection/>

                            <SupportSection/>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
